import React from 'react';
import style from './Switch.module.scss';

interface IProps{
  setYearly: (yearly: boolean) => void;
  yearly: boolean;
}

const Switch = ({ yearly, setYearly }: IProps) => {
  return (
    <div className={style.switch}>
      <label className={style.switch_wrapper}>
        <input type="checkbox" name="price-period" value="Yearly" checked={yearly}/>
        <span className={style.switch_option} onClick={() => setYearly(false)}>Monthly</span>
        <span className={style.switch_toggle} onClick={() => {
          setYearly(!yearly)
        }}></span>
        <span className={style.switch_option} onClick={() => setYearly(true)}>
              Annually
              <span className={style.badge}>save up to 50%</span>
            </span>
      </label>
    </div>
  );
};

export default Switch;
